import * as $ from "jquery";
import * as _ from "lodash";
import { DashboardCategoryCollection } from "../../../collections/DashboardCategories";
import { DashboardChannelCollection } from "../../../collections/DashboardChannels";
import { DashboardNotificationCollection } from "../../../collections/DashboardNotifications";
import { DashboardWidgetCollection } from "../../../collections/DashboardWidgets";
import { StatusNotificationCollection } from "../../../collections/StatusNotifications";
import { Utils } from "../../../common/utils";
import { DashboardRange } from "../../../models/DashboardRange";
import { NewDashboardChannel } from "../../modals/dashboard/modify_widgets/_BaseModifyWidgetView";
import { BaseDetailAccountView } from "../_BaseAccountViews";
import { TeamDetailViewOptions } from "./TeamDetailViews";


require('bootstrap-toggle');


function toTime(v) {
    var hour = Math.floor(v / 3600);
    var minutes = Math.floor((v % 3600) / 60);
    var ampm = ' AM';
    if (hour > 11 && hour < 24) ampm = ' PM';

    if (hour < 1) {
        hour += 12;
    } else if (hour > 12) {
        hour -= 12;
    }

    return hour + ':' + (minutes === 0 ? '00' : minutes) + ampm;
}

function updateSliderText(elem, val, on, swapInterval) {
    var text;
    if (!on) {
        text = '';
    } else {
        if (swapInterval) {
            text = "Don't send notifications from <b>" + toTime(val[1]) + '</b> to <b>' + toTime(val[0]) + '</b>';
        } else {
            text = "Don't send notifications from <b>" + toTime(val[0]) + '</b> to <b>' + toTime(val[1]) + '</b>';
        }
    }
    elem.html(text);
}

interface DashboardNotificationViewOptions extends TeamDetailViewOptions {
    dashboardNotificationCollection: DashboardNotificationCollection;
    dashboardId: number
}

interface InstallationNotificationViewOptions extends TeamDetailViewOptions {
    statusNotificationCollection: StatusNotificationCollection;
    installId: number;
}


export class DashboardNotificationsView extends BaseDetailAccountView {

    options: DashboardNotificationViewOptions;

    protected template = _.template(require('templates/account/notifications/dashboardNotifications.html'));
    protected thresholdTemplate = _.template(require('templates/modals/dashboard/modify_widgets/shared/threshold.html'));

    protected dashboardCategoryCollection: DashboardCategoryCollection = null;
    protected dashboardChannelCollection: DashboardChannelCollection = new DashboardChannelCollection();
    private dashboardWidgetCollection: DashboardWidgetCollection = null;

    constructor(options: DashboardNotificationViewOptions) {
        super(<any>_.extend(options, {
            events: {
                'submit .dashboard-notification-form': 'submitDashboardNotificationForm',
                'input .dashboard-channel-samples': 'handleDashboardChannelSamplesChange',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds-limits input': 'handleThresholdsInput',

                //Ranges
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleRangeInput'
            }
        }));
    }

    show() {

        $.when(this.options.dashboardNotificationCollection.fetch()).done(() => {
            // Render a single dashboard notification
            this.model = this.options.dashboardNotificationCollection.findWhere({
                dashboard_id: this.options.dashboardId
            });

            if (!this.model) {
                // This is a new notification. Create a new model
                this.model = new this.options.dashboardNotificationCollection.model({
                    dashboard_id: this.options.dashboardId
                });
                this.options.dashboardNotificationCollection.add(this.model);
            }

            this.dashboardCategoryCollection = new DashboardCategoryCollection([], {
                dashboardId: this.options.dashboardId
            });

            this.dashboardChannelCollection = new DashboardChannelCollection([], {
                dashboardId: this.options.dashboardId
            });

            this.dashboardWidgetCollection = new DashboardWidgetCollection([], {
                dashboardId: this.options.dashboardId
            });


            $.when(
                this.dashboardCategoryCollection.fetch(),
                this.dashboardChannelCollection.fetch(),
                this.dashboardWidgetCollection.getCollectionFetchPromise()
            ).done(() => {
                this.collectionLoaded = true;
                this.render();
            })
        });
    }

    render() {
        const view = this;
        const canEdit = this.collectionLoaded
            && this.options.permissionCollection.canViewUserGroup(this.options.currentUserGroup.get('id'))
            && this.options.permissionCollection.canModifyDashboard(this.model.get('dashboard_id'));

        // Group dashboard channels by category id
        const dashboardChannelsByCategory = new Map();
        this.dashboardChannelCollection.each((channel) => {
            // Filter all channels not from dashboard widgets
            if (!_.includes([
                'channels', 'chart', 'iaq', 'module_layout', 'multi_gauge', 'sensitivity'
            ], channel.get('dashboard_widget_type'))) return;

             //get widget advancedConfig param and add it to channel for use on template
            const widget = this.dashboardWidgetCollection.find((widget) => {
                return widget.get("id") == channel.get('dashboard_widget_id')
            })
            const advancedConfig = !!Number(widget.getParamValue('ADVANCED_CONFIG', false));
            channel.set({ advancedConfig: advancedConfig });

            const categoryId = channel.get('dashboard_category_id');
            if (!dashboardChannelsByCategory.get(categoryId)) dashboardChannelsByCategory.set(categoryId, []);
            dashboardChannelsByCategory.get(categoryId).push(channel);
        });

        this.$el.html(this.template({
            permissionCollection: this.options.permissionCollection,
            dashboardCategoryCollection: this.dashboardCategoryCollection,
            dashboardChannelsByCategory: dashboardChannelsByCategory,
            collectionLoaded: this.collectionLoaded,
            model: this.model,
            userGroupId: this.options.currentUserGroup.get('id'),
            canEdit: canEdit
        }));

        // Set up quiet time sliders and buttons
        (<any>this.$el.find('input[data-toggle="toggle"]')).bootstrapToggle();
        this.$el.find('[data-toggle="toggle"]').change(function () {
            const group = $(this).parents('.quiet-time-group');
            view.updateQuietTimeGroup(group, canEdit);
        });
        (<any>this.$el.find('[data-slider="slider"]')).slider();
        this.$el.find('[data-slider="slider"]').on('slide', function (e: JQuery.UIEventBase) {
            const group = $(e.currentTarget).parents('.quiet-time-group');
            view.updateQuietTimeGroup(group, canEdit);
        });
        this.$el.find('.quiet-time-group').each(function () {
            view.updateQuietTimeGroup($(this), canEdit);
        });

        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        // Initialize Spectrum color picker
        (<any>this.$el.find('.color-picker')).spectrum(this.getSpectrumDefaultOptions());
        this.delegateEvents();

        return this;
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var hidden = thresholdsContainer.hasClass('hidden');
        if (hidden) {
            thresholdsContainer.removeClass('hidden');
        } else {
            thresholdsContainer.addClass('hidden');
        }
    }

    private handleAddThreshold(e: JQuery.UIEventBase) {
        e.preventDefault()
        var currentWrapper = $(e.currentTarget).closest('.channel-thresholds').find('.thresholds-wrapper')
        var unit = $(e.currentTarget).closest('.channel-thresholds').attr('data-channel-unit');
        currentWrapper.append(this.thresholdTemplate({
            id: '',
            name: '',
            value: '',
            unit: unit,
            color: "#e66465",
            aboveThreshold: false
        }));

        (<any>this.$('input[type="checkbox"]')).bootstrapToggle();
        // Initialize Spectrum color picker
        (<any>currentWrapper.find('.color-picker')).spectrum(this.getSpectrumDefaultOptions());

        var notificationsToggleButton = $(e.currentTarget).parents('.channel-row').find('.dashboard-channel-checkbox');
        (<any>notificationsToggleButton).bootstrapToggle('enable');
        notificationsToggleButton.parents('.checkbox').removeClass('disabled');

        var channelThresholdsRow = $(e.currentTarget).closest('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        this.handleRangeInput();
    }

    private handleDeleteThreshold(e) {
        e.preventDefault();
        var channelThresholdsRow = $(e.currentTarget).closest('.channel-thresholds');
        var thresholdsWrapper = $(e.currentTarget).closest('.channel-thresholds').find('.thresholds-wrapper');
        // Remove elements generated by Spectrum Color Picker
        var colorPickerInput = (<any>$(e.currentTarget).closest('.threshold-range').find('.threshold-color.color-picker'));
        colorPickerInput.spectrum("container").remove();
        $(e.currentTarget).parents('.threshold-range').remove();

        var ranges = $(thresholdsWrapper).find('.threshold-range');
        var notificationsToggleButton = $(thresholdsWrapper).closest('.channel-row').find('.dashboard-channel-checkbox');
        if (ranges.length) {
            // There are ranges with valid fields, so the button is clickable
            (<any>notificationsToggleButton).bootstrapToggle('enable');
            // Bootstrap Toggle doesn't seem to automatically remove/add this attribute
            notificationsToggleButton.parents('.checkbox').removeClass('disabled');
        } else {
            // Required ranges fields are empty, so switch button off
            (<any>notificationsToggleButton).bootstrapToggle('off');
            //  Also, make the button unclickable
            (<any>notificationsToggleButton).bootstrapToggle('disable');
            // Mouseover shows visibly disabled element
            notificationsToggleButton.parents('.checkbox').addClass('disabled');
        }

        this.setMultirangeThresholdQty(channelThresholdsRow);
        this.handleRangeInput();
    }

    setMultirangeThresholdQty(channelThresholdsRow) {
        var $currentchannelRow = $(channelThresholdsRow);
        var rangesQty = $currentchannelRow.find('.thresholds-wrapper .threshold-range').length;

        if (rangesQty == 0) {
            $currentchannelRow.find('.threshold-multirange-qty').addClass('empty').html('No Thresholds');
        } else {
            $currentchannelRow.find('.threshold-multirange-qty').removeClass('empty').html(`${rangesQty} Thresholds`);
        }
    }

    getSpectrumDefaultOptions() {
        return {
            type: "color",
            showInput: true,
            hideAfterPaletteSelect: true,
            showAlpha: false,
            allowEmpty: false,
            showPaletteOnly: true,
            togglePaletteOnly: true,
            togglePaletteMoreText: 'more',
            togglePaletteLessText: 'less',
            palette: [
                [Utils.colors.blue, Utils.colors["light-blue"], Utils.colors.green, Utils.colors.yellow],
                [Utils.colors.orange, Utils.colors.red, Utils.colors.purple, Utils.colors.maroon],
            ]
        }
    }

    private handleThresholdsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var unit = targetInput.attr('channel-unit');

        var val = (<string>targetInput.val());
        var addClass = false;
        if (val == '') {
            val = 'N/A';
        } else {
            if (_.isNaN(Number(val))) {
                val = 'N/A';
            } else {
                val += unit;
                addClass = true;
            }
        }

        var allInputs = targetInput.parents('.thresholds').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-thresholds').find('.threshold-badges .badge:eq(' + i + ')');
        badge.text(val);
        if (addClass) {
            if (badge.hasClass('crit-low') || badge.hasClass('crit-high')) {
                badge.addClass('danger');
            } else {
                badge.addClass('warning');
            }
        } else {
            badge.removeClass('danger').removeClass('warning');
        }

        // Make enable/disable button clickable (or not) depending on whether the channel has thresholds
        var thresholds: string =
            <string>targetInput.parents('.channel-thresholds').find('input.crit-low').val() +
            <string>targetInput.parents('.channel-thresholds').find('input.warn-low').val() +
            <string>targetInput.parents('.channel-thresholds').find('input.warn-high').val() +
            <string>targetInput.parents('.channel-thresholds').find('input.crit-high').val();
        // Make sure the user has only entered valid (numeric) thresholds
        var hasThresholds: number = Number(thresholds);

        var notificationsToggleButton = targetInput.parents('.channel-row').find('.dashboard-channel-checkbox');
        if (hasThresholds) {
            // There are user-set thresholds, so the button is clickable
            (<any>notificationsToggleButton).bootstrapToggle('enable');
            // Bootstrap Toggle doesn't seem to automatically remove/add this attribute
            notificationsToggleButton.parents('.checkbox').removeClass('disabled');
        } else {
            // No thresholds set, so switch button off
            (<any>notificationsToggleButton).bootstrapToggle('off');
            //  Also, make the button unclickable
            (<any>notificationsToggleButton).bootstrapToggle('disable');
            // Mouseover shows visibly disabled element
            notificationsToggleButton.parents('.checkbox').addClass('disabled');
        }
    }

    private handleRangeInput() {
        $('.save-notifications-btn').prop('disabled', !this.canSaveRanges());
    }

    canSaveRanges() {
        var canSave = true;
        _.each(this.$('.thresholds-wrapper'), (wrapper) => {
            var values = [];

            _.each($(wrapper).find('.threshold-range'), (rangeRow) => {
                var value = $(rangeRow).find('.threshold-value').val();
                var name = $(rangeRow).find('.threshold-name').val();

                // Check for empty name or empty value
                if (name == '' || value == '') {
                    canSave = false;
                    return false;
                }
                values.push(Number(value));
            });

            // Check for repeated values
            if (_.uniq(values).length !== values.length) canSave = false;

            if (!canSave) return false;
        });
        return canSave;
    }

    private submitDashboardNotificationForm(e: JQuery.UIEventBase) {
        e.preventDefault();

        // Process differences in channels, to be updated at the end of this method
        var diff = this.getChannelDifference();

        var form = $(e.currentTarget);
        var model = this.options.dashboardNotificationCollection.get(<string>form.attr('data-model-cid'));

        this.$('.dashboard-channel-errors').addClass('hidden');
        var errors = [];

        // Check channels and validate number of samples
        var channels = [];
        var dashboardChannelRows = this.$('.dashboard-channel');
        var numSamplesError = false;
        dashboardChannelRows.each(function () {
            var enabled = $(this).find('.dashboard-channel-checkbox').prop('checked');
            if (!enabled) return;

            var samples = Number($(this).find('.dashboard-channel-samples').val());
            if (_.isNaN(samples) || samples < 1 || samples > 4000000000) {
                if (!numSamplesError) errors.push('The Number of Samples must be between 1 and 4,000,000,000');
                numSamplesError = true;
                return;
            }

            channels.push({
                id: Number($(this).attr('data-dashboard-channel-id')),
                num_samples: samples
            });
        });

        // If there are validation errors show them and quit
        if (errors.length) {
            this.$('.dashboard-channel-errors').removeClass('hidden').find('p').html(
                errors.join('<br>')
            );
            $('html, body').animate({
                scrollTop: ($('.dashboard-channel-errors').offset().top - 200)
            }, 100);
            return;
        }

        // Quiet Times
        var reversed, vals;
        var qt_wd_enabled = form.find('.notification-weekday-quiet-group .quiet-time-checkbox').prop('checked');
        var qt_wd_start = null, qt_wd_end = null;
        if (qt_wd_enabled) {
            reversed = !form.find('.notification-weekday-quiet-group .quiet-time-day').prop('checked');
            vals = (<any>form.find('.notification-weekday-quiet-group .quiet-time-slider')).slider('getValue');
            vals = this.normalizeSliderValues(vals);

            if (reversed) {
                qt_wd_start = vals[1];
                qt_wd_end = vals[0];
            } else {
                qt_wd_start = vals[0];
                qt_wd_end = vals[1];
            }
        }
        var qt_we_enabled = form.find('.notification-weekend-quiet-group .quiet-time-checkbox').prop('checked');
        var qt_we_start = null, qt_we_end = null;
        if (qt_we_enabled) {
            reversed = !form.find('.notification-weekend-quiet-group .quiet-time-day').prop('checked');
            vals = (<any>form.find('.notification-weekend-quiet-group .quiet-time-slider')).slider('getValue');
            vals = this.normalizeSliderValues(vals);

            if (reversed) {
                qt_we_start = vals[1];
                qt_we_end = vals[0];
            } else {
                qt_we_start = vals[0];
                qt_we_end = vals[1];
            }
        }

        model.set({
            enable_email_notifications: form.find('.notification-email-enabled').prop('checked'),
            enable_sms_notifications: form.find('.notification-sms-enabled').prop('checked'),
            enable_ok_notifications: form.find('.notification-ok-enabled').prop('checked'),
            digest_interval: Number(form.find('.notification-digest-interval').val()),
            quiet_time_weekday_start_seconds: qt_wd_start,
            quiet_time_weekday_end_seconds: qt_wd_end,
            quiet_time_weekend_start_seconds: qt_we_start,
            quiet_time_weekend_end_seconds: qt_we_end,
            dashboard_channels: channels
        });

        this.collectionLoaded = false;
        this.render();

        return $.when(model.save(),
            // Update channels using 'diff' produced at the top of this method
            $.ajax({
                type: "PUT",
                url: this.dashboardChannelCollection.url(),
                data: JSON.stringify({
                    update: diff
                }),
                dataType: 'json',
                contentType: "application/json; charset=utf-8"
            })).then(() => {
                this.reloadUrl();
            });
    }

    private updateQuietTimeGroup($group, canEdit) {
        var sliderEnabled = $group.find('.quiet-time-checkbox').prop('checked') && canEdit;
        var reversedCheckbox = $group.find('.quiet-time-day');
        var reversed = !reversedCheckbox.prop('checked');
        var slider = $group.find('.quiet-time-slider');
        var sliderUI = $group.find('.slider');
        var label = $group.find('.quiet-time-label');

        updateSliderText(label, this.normalizeSliderValues(slider.slider('getValue')), sliderEnabled, reversed);
        if (sliderEnabled) {
            slider.slider('enable');
            reversedCheckbox.bootstrapToggle('enable');
        } else {
            slider.slider('disable');
            reversedCheckbox.bootstrapToggle('disable');
        }
        reversed ? sliderUI.addClass('inverted') : sliderUI.removeClass('inverted');
    }

    private normalizeSliderValues(sliderVals) {
        if (sliderVals[0] < sliderVals[1]) return sliderVals;
        return [sliderVals[1], sliderVals[0]]
    }

    private getChannelDifference() {
        var update = {};
        var $rows = this.$('.channel-row');
        var i = 0;

        _.each($rows, (row) => {
            var $row = $(row);
            var dashboardChannelId = Number($row.find('div[data-dashboard-channel-id]').data('dashboardChannelId'));
            var widgetId = this.dashboardChannelCollection.get(dashboardChannelId).get('dashboard_widget_id');
            var name: string = $row.find('.dashboard-channel-name').text();

            var dashboardChannel = this.dashboardChannelCollection
                .findWhere({ dashboard_channel_id: dashboardChannelId });

            //get advancedConfig data att from template and get ranges accordingly
            var advancedConfig = $row.data('advanced-config');
            var rangesList = advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);


            var channelId = dashboardChannel.get('channel_id');
            var order = dashboardChannel.get('dashboard_channel_order');
            var secondary_order = dashboardChannel.get('dashboard_channel_secondary_order');

            var upsert: NewDashboardChannel = {
                dashboardId: this.options.dashboardId,
                widgetId: widgetId,
                channelId: channelId,
                order: order, // Use channel's existing value
                secondary_order: secondary_order, // Use channel's existing value
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };

            // Add a key/value pair to update: { dashboardChannelId : upsert }
            update[dashboardChannelId] = upsert;
            // Increment order
            i++;
        });

        return update
    }

    getRangesListFromRegularThresholds(channelRow) {
        var $row = $(channelRow);
        var rangesList = [];

        var limitCritLow: any = $row.find('.thresholds .crit-low').val();
        limitCritLow = limitCritLow === '' ? null : Number(limitCritLow);
        if (isNaN(limitCritLow)) limitCritLow = null;

        var limitWarnLow: any = $row.find('.thresholds .warn-low').val();
        limitWarnLow = limitWarnLow === '' ? null : Number(limitWarnLow);
        if (isNaN(limitWarnLow)) limitCritLow = null;

        var limitWarnHigh: any = $row.find('.thresholds .warn-high').val();
        limitWarnHigh = limitWarnHigh === '' ? null : Number(limitWarnHigh);
        if (isNaN(limitWarnHigh)) limitCritLow = null;

        var limitCritHigh: any = $row.find('.thresholds .crit-high').val();
        limitCritHigh = limitCritHigh === '' ? null : Number(limitCritHigh);
        if (isNaN(limitCritHigh)) limitCritLow = null;

        // Critical - Low
        if (limitCritLow != null) {
            const limitCritLowId = $row.find('.thresholds .crit-low').data('range-id');
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: (limitCritLowId) ? Number(limitCritLowId) : null,
                name: "Critical Low",
                min: null,
                max: limitCritLow,
                color: Utils.colors.red,
                description: 'Value below threshold',
            });
            rangesList.push(thresholdRange);
        }
        // Warning - Low
        if (limitWarnLow != null) {
            const limitWarnLowId = $row.find('.thresholds .warn-low').data('range-id');
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: (limitWarnLowId) ? Number(limitWarnLowId) : null,
                name: "Warning Low",
                min: null,
                max: limitWarnLow,
                color: Utils.colors.yellow,
                description: 'Value below threshold',
            });
            if (limitCritLow != null) {
                thresholdRange.setMin(limitCritLow);
            }
            rangesList.push(thresholdRange);
        }
        //Create default range
        var thresholdRange = new DashboardRange({
            name: "Good",
            description: 'Value within threshold',
            color: Utils.colors.green,
            is_default: true,
            min: null,
            max: null
        });
        if (limitWarnLow != null) {
            thresholdRange.setMin(limitWarnLow);
        } else if (limitCritLow != null) {
            thresholdRange.setMin(limitCritLow);
        }
        if (limitWarnHigh != null) {
            thresholdRange.setMax(limitWarnHigh);
        } else if (limitCritHigh != null) {
            thresholdRange.setMax(limitCritHigh);
        }
        rangesList.push(thresholdRange);

        // Warning - High
        if (limitWarnHigh != null) {
            const limitWarnHighId = $row.find('.thresholds .warn-high').data('range-id');
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: (limitWarnHighId) ? Number(limitWarnHighId) : null,
                name: "Warning High",
                min: limitWarnHigh,
                max: null,
                color: Utils.colors.yellow,
                description: 'Value above threshold',
            });
            if (limitCritHigh != null) {
                thresholdRange.setMax(limitCritHigh);
            }
            rangesList.push(thresholdRange);
        }
        // Critical - High
        if (limitCritHigh != null) {
            const limitCritHighId = $row.find('.thresholds .crit-high').data('range-id');
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: (limitCritHighId) ? Number(limitCritHighId) : null,
                name: "Critical High",
                min: limitCritHigh,
                max: null,
                color: Utils.colors.red,
                description: 'Value above threshold',
            });
            rangesList.push(thresholdRange);
        }

        return rangesList;
    }

    //Get channel ranges
    getRangesListFromAdvancedThresholds(channelRow) {
        var $row = $(channelRow);

        //Create default range
        var defaultRange = new DashboardRange({
            name: "Good",
            description: 'Value within threshold',
            color: Utils.colors.green,
            is_default: true,
            min: null,
            max: null
        });

        // If there are no ranges, return the default range
        var wrapper: any = $row.find('.thresholds-wrapper');
        if (wrapper.is(':empty')) return [defaultRange];

        var rangesBelowThreshold = [];
        var rangesAboveThreshold = [];
        _.each(wrapper.find('.threshold-range'), (rangeRow) => {
            var range = new DashboardRange()
            var value = $(rangeRow).find('.threshold-value').val()
            var name = $(rangeRow).find('.threshold-name').val()

            range.set({
                id: $(rangeRow).data('range-id') ?? null,
                name: name,
                description: $(rangeRow).find('.threshold-ab-checkbox').is(':checked') ? 'Value above threshold' : 'Value below threshold',
                aboveThreshold: $(rangeRow).find('.threshold-ab-checkbox').is(':checked') ? true : false,
                val: Number(value),
                color: $(rangeRow).find('.threshold-color').val(),
                is_default: false
            })
            range.get('aboveThreshold') ? range.setIcon('fa-circle-arrow-up') : range.setIcon('fa-circle-arrow-down');
            range.get('aboveThreshold') ? rangesAboveThreshold.push(range) : rangesBelowThreshold.push(range);
        });

        // Sort ranges below threshold by value and assign min and max values
        rangesBelowThreshold = _.sortBy(rangesBelowThreshold, r => r.get('val'));
        _.each(rangesBelowThreshold, (range, idx) => {
            idx == 0 ? range.setMin(null) : range.setMin(rangesBelowThreshold[idx - 1].get('val'));
            range.setMax(range.get('val'))
        });

        // Set min and max values for default range
        defaultRange.set({
            min: _.last(rangesBelowThreshold) ? _.last(rangesBelowThreshold).get('val') : null,
            max: _.head(rangesAboveThreshold) ? _.head(rangesAboveThreshold).get('val') : null
        });

        // Sort ranges above threshold by value and assign min and max values
        rangesAboveThreshold = _.sortBy(rangesAboveThreshold, r => r.get('val'));
        _.each(rangesAboveThreshold, (range, idx) => {
            range.setMin(range.get('val'))
            idx == (rangesAboveThreshold.length - 1) ? range.setMax(null) : range.setMax(rangesAboveThreshold[idx + 1].get('val'));
        });

        // Merge all ranges
        rangesBelowThreshold.push(defaultRange);
        return _.union(rangesBelowThreshold, rangesAboveThreshold);
    }

    handleDashboardChannelSamplesChange(e: JQuery.UIEventBase) {
        var $target = $(e.currentTarget);
        var $parent = $target.parents('.dashboard-channel');
        // Automatically enable the channel if the number of samples changes
        (<any>$parent.find('.dashboard-channel-checkbox')).bootstrapToggle('on');

        var samples = Number($target.val());

        if (!samples || _.isNaN(samples)) return;

        var channelId = Number($parent.attr('data-dashboard-channel-id'));
        var dashboardChannel = this.dashboardChannelCollection.findWhere({ dashboard_channel_id: channelId });
        var sampleText = '';
        if (samples == 1) {
            sampleText = '(Immediately)';
        } else {
            sampleText = '(' + ((samples - 1) * Number(dashboardChannel.get('module_polling_frequency'))) + ' seconds)';
        }
        $target.parents('.dashboard-channel').find('.dashboard-channel-samples-label').text(sampleText);
    }
}

export class InstallNotificationsView extends BaseDetailAccountView {

    options: InstallationNotificationViewOptions;
    protected template = _.template(require('templates/account/notifications/statusNotifications.html'));

    constructor(options: InstallationNotificationViewOptions) {
        super(<any>_.extend(options, {
            events: {
                'submit .status-notification-form': 'submitStatusNotificationForm',
            }
        }));
    }

    show() {
        this.collectionLoaded = true;
        this.render()
    }

    render() {
        var model = this.options.statusNotificationCollection.findWhere({
            install_id: this.options.installId
        });

        if (!model) {
            model = new this.options.statusNotificationCollection.model({
                install_id: this.options.installId,
                usergroup_id: this.options.currentUserGroup.get('id'),
                enable_email_notifications: false,
                enable_sms_notifications: false,
                digest_interval: 300,
                quiet_time_weekday_start_seconds: null,
                quiet_time_weekday_end_seconds: null,
                quiet_time_weekend_start_seconds: null,
                quiet_time_weekend_end_seconds: null
            });
            this.options.statusNotificationCollection.add(model)
        }

        var view = this;
        var canEdit = this.options.permissionCollection.canViewUserGroup(this.options.currentUserGroup.get('id'))
            && this.options.permissionCollection.canModifyInstall(model.get('install_id'));

        this.$el.html(this.template({
            model: model,
            permissionCollection: this.options.permissionCollection,
            userGroupId: this.options.currentUserGroup.get('id'),
            canEdit: canEdit
        }));

        // Set up quiet time sliders and buttons
        (<any>this.$el.find('input[data-toggle="toggle"]')).bootstrapToggle();
        (<any>this.$el.find('[data-toggle="toggle"]')).change(function () {
            var group = $(<JQuery.Selector>this).parents('.quiet-time-group');
            view.updateQuietTimeGroup(group, canEdit);
        });
        (<any>this.$el.find('[data-slider="slider"]')).slider();
        (<any>this.$el.find('[data-slider="slider"]')).on('slide', function (e: JQuery.UIEventBase) {
            var group = $(e.currentTarget).parents('.quiet-time-group');
            view.updateQuietTimeGroup(group, canEdit);
        });
        (<any>this.$el.find('.quiet-time-group')).each(function () {
            view.updateQuietTimeGroup($(this), canEdit);
        });

        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    private updateQuietTimeGroup($group, canEdit) {
        var sliderEnabled = $group.find('.quiet-time-checkbox').prop('checked') && canEdit;
        var reversedCheckbox = $group.find('.quiet-time-day');
        var reversed = !reversedCheckbox.prop('checked');
        var slider = $group.find('.quiet-time-slider');
        var sliderUI = $group.find('.slider');
        var label = $group.find('.quiet-time-label');

        updateSliderText(label, this.normalizeSliderValues(slider.slider('getValue')), sliderEnabled, reversed);
        if (sliderEnabled) {
            slider.slider('enable');
            reversedCheckbox.bootstrapToggle('enable');
        } else {
            slider.slider('disable');
            reversedCheckbox.bootstrapToggle('disable');
        }
        reversed ? sliderUI.addClass('inverted') : sliderUI.removeClass('inverted');
    }

    private normalizeSliderValues(sliderVals) {
        if (sliderVals[0] < sliderVals[1]) return sliderVals;
        return [sliderVals[1], sliderVals[0]]
    }

    private submitStatusNotificationForm(e: JQuery.UIEventBase) {
        e.preventDefault();

        var form = $(e.currentTarget);
        var model = this.options.statusNotificationCollection.get(<string>form.attr('data-model-cid'));
        // Quiet Times
        var reversed, vals;
        var qt_wd_enabled = form.find('.notification-weekday-quiet-group .quiet-time-checkbox').prop('checked');
        var qt_wd_start = null, qt_wd_end = null;
        if (qt_wd_enabled) {
            reversed = !form.find('.notification-weekday-quiet-group .quiet-time-day').prop('checked');
            vals = (<any>form.find('.notification-weekday-quiet-group .quiet-time-slider')).slider('getValue');
            vals = this.normalizeSliderValues(vals);

            if (reversed) {
                qt_wd_start = vals[1];
                qt_wd_end = vals[0];
            } else {
                qt_wd_start = vals[0];
                qt_wd_end = vals[1];
            }
        }
        var qt_we_enabled = form.find('.notification-weekend-quiet-group .quiet-time-checkbox').prop('checked');
        var qt_we_start = null, qt_we_end = null;
        if (qt_we_enabled) {
            reversed = !form.find('.notification-weekend-quiet-group .quiet-time-day').prop('checked');
            vals = (<any>form.find('.notification-weekend-quiet-group .quiet-time-slider')).slider('getValue');
            vals = this.normalizeSliderValues(vals);

            if (reversed) {
                qt_we_start = vals[1];
                qt_we_end = vals[0];
            } else {
                qt_we_start = vals[0];
                qt_we_end = vals[1];
            }
        }

        model.set({
            enable_email_notifications: form.find('.notification-email-enabled').prop('checked'),
            enable_sms_notifications: form.find('.notification-sms-enabled').prop('checked'),
            enable_ok_notifications: false,
            digest_interval: Number(form.find('.notification-digest-interval').val()),
            quiet_time_weekday_start_seconds: qt_wd_start,
            quiet_time_weekday_end_seconds: qt_wd_end,
            quiet_time_weekend_start_seconds: qt_we_start,
            quiet_time_weekend_end_seconds: qt_we_end
        });

        this.collectionLoaded = false;
        this.render();
        $.when(model.save()).done(() => {
            this.reloadUrl();
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/team/NotificationsView.ts